import React from 'react'
import Animated, { FadeInDown } from 'react-native-reanimated'
import { ViewStyle } from 'react-native'

interface AnimatedItemProps {
  index: number
  children: React.ReactNode
  style?: ViewStyle
}

export default function AnimatedItem({ index, children, style }: AnimatedItemProps) {
  return (
    <Animated.View
      entering={FadeInDown.delay(Math.min(index, 10) * 50).duration(300).springify()}
      style={style}
    >
      {children}
    </Animated.View>
  )
}
